import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ROUTER_FUTURE_FLAGS } from "./lib/routerFuture";
import { getApiKey, setApiKey } from "./lib/apiKey";
import "./styles/globals.css";

// Seed owner API key from VITE_OWNER_API_KEY if not already in localStorage.
// Set this in .env.local — never commit the value.
const _ownerKey = (import.meta.env.VITE_OWNER_API_KEY as string | undefined)?.trim();
if (_ownerKey && !getApiKey()) setApiKey(_ownerKey);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter future={ROUTER_FUTURE_FLAGS}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Crossfade the static index.html loader into the mounted app once React has
// painted (double rAF = after the first commit is on screen), instead of an
// abrupt swap.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById("root")?.classList.add("app-root-visible");
    const loader = document.getElementById("app-loader");
    if (!loader) return;
    loader.classList.add("app-loader-hidden");
    loader.addEventListener("transitionend", () => loader.remove(), { once: true });
  });
});
